import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SortControls = ({ sortBy, onSortChange, viewMode, onViewModeChange }) => {
  const sortOptions = [
    { value: 'relevance', label: 'Relevance', icon: 'Star' },
    { value: 'impact', label: 'Impact Rating', icon: 'TrendingUp' },
    { value: 'transparency', label: 'Transparency', icon: 'Shield' },
    { value: 'efficiency', label: 'Efficiency', icon: 'Target' },
    { value: 'newest', label: 'Newest', icon: 'Clock' },
    { value: 'alphabetical', label: 'A-Z', icon: 'ArrowUpDown' }
  ];

  const viewModes = [
    { value: 'grid', icon: 'Grid3X3', tooltip: 'Grid view' },
    { value: 'list', icon: 'List', tooltip: 'List view' }
  ];

  return (
    <div className="flex items-center justify-between bg-card border border-border rounded-lg p-4 mb-6">
      {/* Sort Options */}
      <div className="flex items-center space-x-2">
        <Icon name="ArrowUpDown" size={16} className="text-muted-foreground" />
        <span className="text-sm font-medium text-card-foreground mr-2">Sort by:</span>
        <div className="flex flex-wrap gap-1">
          {sortOptions?.map((option) => (
            <Button
              key={option?.value}
              variant={sortBy === option?.value ? "default" : "ghost"}
              size="sm"
              onClick={() => onSortChange(option?.value)}
              iconName={option?.icon}
              iconPosition="left"
              className="text-xs"
            >
              <span className="hidden sm:inline">{option?.label}</span>
            </Button>
          ))}
        </div>
      </div>
      {/* View Mode Toggle */}
      <div className="flex items-center space-x-1 border border-border rounded-lg p-1">
        {viewModes?.map((mode) => (
          <Button
            key={mode?.value}
            variant={viewMode === mode?.value ? "default" : "ghost"}
            size="sm"
            onClick={() => onViewModeChange(mode?.value)}
            title={mode?.tooltip}
            className="w-8 h-8 p-0"
          >
            <Icon name={mode?.icon} size={16} />
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SortControls;